/**
 * @return {boolean} true when `date1` and `date2` fall on the same calendar day.
 */
export const isSameDay = (date1: Date, date2: Date): boolean =>
  date1.getFullYear() === date2.getFullYear() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getDate() === date2.getDate();

/**
 * Parse the date from API response.
 */
export const parseDateForAPI = (date: Date | null): string => {
  const pad = (number: number) => (number < 10 ? '0' + number : number);

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};
